import { Box, Modal } from "@mui/material";
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { setUserDetails } from "../../../redux/cookiesReducer";
import { useDispatch } from "react-redux";

const PatientSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [showloagout, setshowloagout] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { title: "Dashboard", icon: "📈", path: "/Dashboradpatient" },
    { title: "Appointments", icon: "📅", path: "/Appointmentspatients" },
    { title: "Financial", icon: "💰", path: "/Financialpatient" },
    { title: "Messages", icon: "💬", path: "/Messagespatient" },
    { title: "My Profile", icon: "👤", path: "/PatientProfiles" },
    { title: "MyChart", icon: "📊", path: "/MyChart" },
    { title: "Settings", icon: "⚙️", path: "/Settingspatient" },
    { title: "Help & Support", icon: "🆘", path: "/HelpSupportpatient" },
  ];
  const handleLogout = () => {
    setshowloagout(true);
  };
  const handleClose = () => {
    setshowloagout(false);
  };
  const handleLogoutYes = () => {
    dispatch(setUserDetails(null));
    navigate("/");
  };

  return (

    <>
      <button className="mobile-menu-icon" onClick={() => setIsOpen(!isOpen)}>
        ☰
      </button>

      <div
        className={`overlay ${isOpen ? "active" : ""}`}
        onClick={() => setIsOpen(false)}
      ></div>

      <div className={`sidebar-wrapper ${isOpen ? "open" : ""}`}>
        <div className="logo_sidebar">
          <div className="logo-icon">
            <i className="fas fa-stethoscope" />
          </div>
          <p>
            <strong>EnnVital</strong>
            <br />
            <small>
              Empowering Health
              <br />
              Connecting Care
            </small>
          </p>
        </div>

        <div className="divider_sidebar" />

        <nav className="menu-list">
          {menuItems.map((item, index) => {
            const isActive = location.pathname === item.path;
            return (
              <div
                key={index}
                className={`menu-item ${isActive ? "active" : ""}`}
                onClick={() => {
                  navigate(item.path);
                  setIsOpen(false); // close sidebar on mobile
                }}
              >
                <span className="menu-icon">{item.icon}</span>
                <span className="menu-title">{item.title}</span>
              </div>
            );
          })}

          <div
            className="menu-item logout"
            onClick={() => {
              setshowloagout(true);
              setIsOpen(false);
            }}
          >
            <span className="menu-icon">🚪</span>
            <span className="menu-title">Log Out</span>
          </div>
        </nav>

        <Modal
          open={showloagout}
          onClose={() => setshowloagout(false)}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box sx={modalStyle}>
            <div className="logout-modal">
              <div className="logout_txt">Logout</div>
              <div
                className="logout_sure"
                style={{ marginBottom: 20, marginTop: 10 }}
              >
                Are you sure to logout your account?
              </div>
              <div className="logout-buttons">
                <button
                  className="cancel-button"
                  onClick={() => setshowloagout(false)}
                >
                  No
                </button>
                <button className="confirm-button" onClick={handleLogoutYes}>
                  Yes
                </button>
              </div>
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default PatientSidebar;
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
};
